import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

import { logLevel } from "../models/logging";

@Injectable({
  providedIn: "root",
})
export class LoggerService {
  public readonly logLevel: logLevel = environment.log_level;

  private shouldLog(level: logLevel): boolean {
    return level <= this.logLevel;
  }

  private write(level: logLevel, ...msgs: any[]) {
    if (this.shouldLog(level)) {
      console.log(...msgs);
    }
  }

  public error(...msgs: any[]): void {
    if (this.shouldLog(logLevel.ERROR)) {
      console.error(...msgs);
    }
  }

  public warning(...msgs: any[]): void {
    if (this.shouldLog(logLevel.WARNING)) {
      console.warn(...msgs);
    }
  }

  public info(...msgs: any[]): void {
    this.write(logLevel.INFO, ...msgs);
  }

  public log(...msgs: any[]): void {
    this.info(...msgs);
  }

  public debug(...msgs: any[]): void {
    this.write(logLevel.DEBUG, ...msgs);
  }
}
